import { render, staticRenderFns } from "./problem_description.vue?vue&type=template&id=1c9f6d9b&"
import script from "./problem_description.vue?vue&type=script&lang=js&"
export * from "./problem_description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports